import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { ReactNode } from 'react';

interface Allergen {
    examples: ReactNode;
    allergenName: any;
    id: number;
    name: string;
}

interface AllergenceState {
    data: Allergen[];
    loading: boolean;
    error: string | null;
}

const PORT = import.meta.env.VITE_COOK_PORT;
const MASTERURL = import.meta.env.VITE_API_COOK_URL;

interface ApiResponse {
    data: Allergen[];
}

export const fetchAllergence = createAsyncThunk<Allergen[], void, { rejectValue: string }>(
    'allergence/fetchAllergence',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.get<ApiResponse>('/get_all_allergen_type', PORT, MASTERURL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);
export const createAllergence: any = createAsyncThunk(
    'allergence/createAllergence', async (params: any, thunkAPI) => {
        console.log(params)
        try {
            const response = await apiService.post('create_allergen_type', params, PORT, MASTERURL);
            return response
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

export const updateAllergence: any = createAsyncThunk(
    'allergence/updateAllergence',
    async (params: any, thunkAPI) => {
        console.log(params)
        try {
            const response = await apiService.put('update_allergen_type', params, PORT, MASTERURL);
            return response
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);





export const deleteAllergence: any = createAsyncThunk<
    number,
    number
>(
    "dietType/deleteDietType",
    async (id,) => {
        try {
            const response = await apiService.patch(
                `soft_delete_allergen_type?id=${id}`,
                {},// adjust endpoint if different
                PORT,
                MASTERURL
            );
            return response
        } catch (error: any) {
            return (
                error?.message || "An error occurred while deleting cuisine type"
            );
        }
    }
);

export const allergenceSlice = createSlice({
    name: 'allergence',
    initialState: {
        data: [] as Allergen[],
        loading: false,
        error: null,
    } as AllergenceState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllergence.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllergence.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchAllergence.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(createAllergence.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createAllergence.fulfilled, (state, action: PayloadAction<any>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(createAllergence.rejected, (state, action: PayloadAction<string>) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(updateAllergence.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateAllergence.fulfilled, (state, action: PayloadAction<any>) => {
                state.loading = false;
                const updatedTable = action.payload;
            })
            .addCase(updateAllergence.rejected, (state, action: PayloadAction<string>) => {
                state.loading = false;
                state.error = action.payload;
            })

    },
});

export default allergenceSlice.reducer;